<script>
export default {
    name: "VoucherDetails",

    data() {

        return {
            memo: ``,
        };
    },

    props: {

        showModal: Boolean,
        voucher: Object,
        consultant: Object,
         
        cancel: Boolean,
    },

    computed: {

        // total() {
        //     if(!this.voucherItems.voucherDetails.length) return 0;

        //     return this.voucherItems.voucherDetails
        //         .map(voucherItem => parseFloat(voucherItem.voucherAmount))
        //         .reduce((sum,amt) => sum+amt);
        // },

        // customDeductions() {

        //     if(!this.voucherItems.dedcutions.length) return 0;

        //     const customDeductions = this.voucherItems.dedcutions.filter(ded => !ded.isKra);


        //     return customDeductions.length ? customDeductions.map(deduction => deduction.deductionAmount)
        //         .reduce((sum,amt) => sum+amt) : 0;
        // },

        // kraDeductions() {

        //     if(!this.voucherItems.dedcutions.length) return 0;

        //     const deductions = this.voucherItems.dedcutions.filter(ded => ded.isKra);


        //     return deductions.length ? deductions.map(deduction => deduction.deductionAmount)
        //         .reduce((sum,amt) => sum+amt) : 0;
        // },

        // consultantPayDetails() {
        //     if(!this.voucherItems.voucherDetails.length) return [];

        //     return this.voucherItems.voucherDetails.map(voucherItem => {
        //         return {
        //             id: voucherItem.id,
        //             invoiceDetailID: voucherItem.invoiceDetailID,
        //             amountPaid: voucherItem.voucherAmount,
        //         };
        //     });
        // },

        // cancelVoucherData() {

        //     return {
        //         voucherNo: this.voucher.voucherNo,
        //         payeeName: this.voucher.payeeName,
        //         payeeID: this.voucher.payeeId,
        //         txnDate: window.moment().format(`YYYY-MM-DD`),
        //         userName: this.$root.username,
        //         memo: this.memo,
        //         voucherPayDetails: this.consultantPayDetails,
        //     };
        // },
    },

    methods: {

        // cancelVoucher() {
        //     if(!window.confirm('Confirm Cancel Voucher')) return;

        //     this.$root.loading=true;
        //     this.$http.post(`Finance/CancelPaymentVoucher`,this.cancelVoucherData).then(response => {
        //         this.$emit(`refresh`);
        //         this.$emit(`closeModal`);
        //         this.$root.loading=false;
        //         window.Swal.fire({type: `success`, text: response.data.userMessage});
        //     }).catch(() => {this.$root.loading=false;});
        // },
printslip(){
 window.print();
},
        printPaymentSlip() {
            const remitanceNo = this.voucher.remittanceNo;
            const supplierLid = this.consultant.id
            let url = `/finance-dashboard/supplierpayment/print/${remitanceNo}?supplierId=${supplierLid}`;
            
            window.open(url, 
                '_blank', `PaymentSplipPrint`);
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-3/4 sm:w-11/12">
  <template v-slot:title>
    <h5 class="font-medium text-base">Supplier Payment Details</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full flex flex-wrap p-3 bg-gray-200">
            <div class="flex-1">
                <h5 class="text-base font-medium">Supplier: {{consultant.name}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">Contact: {{consultant.cellPhone || `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">Pin No: {{consultant.piN_No || `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">Website: {{consultant.website || `-`}}</h5>
            </div>
          
        </div>
        <div class="w-full p-3 text-center my-1">
            <h5 class="text-lg uppercase">Remittance NO: 
                 {{voucher.remittanceNo}}</h5>
        </div>
        <div class="w-full overflow-auto">
           <!-- <table class="table">
                <thead class="bg-blue-500 font-medium text-sm text-white">
                    <tr class="border-b-2">
                        <th class="p-tiny">Bill Date</th>
                        <th class="p-tiny">Patient</th>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny text-right">Balance</th>
                        <th class="p-tiny text-right">Voucher Amount</th>
                    </tr>
                </thead>
                <tbody class="text-sm bg-gray-200">
                    <tr class="border-b-2" v-for="(voucherItem,idx) in voucherItems.voucherDetails" :key="idx">
                        <td class="p-tiny">{{voucherItem.billDate | dateFormat}}</td>
                        <td class="p-tiny">
                            <h5 class="font-medium">{{voucherItem.patientName}}</h5>
                            <h5 class="font-medium">MRN:{{voucherItem.patientID}}</h5>
                        </td>
                        <td class="p-tiny">{{voucherItem.itemName}}</td>
                        <td class="p-tiny">{{voucherItem.quantity}}</td>
                        <td class="p-tiny text-right">{{voucherItem.grandTotal | numberFormat}}</td>
                        <td class="p-tiny text-right">{{voucherItem.voucherAmount | numberFormat}}</td>
                    </tr>
                    <tr>
                        <td colspan="5" class="p-1"></td>
                        <th class="p-tiny text-right text-base">
                            Total: {{total | numberFormat}}
                        </th>
                    </tr>
                    <tr>
                        <th colspan="6" class="p-tiny text-base">Custom Deductions</th>
                    </tr>
                    <tr>
                        <th colspan="2" class="p-tiny">Deduction</th>
                        <th class="p-tiny">Rate</th>
                        <th class="p-tiny">Is KRA</th>
                        <th class="p-tiny">Ref</th>
                        <th class="p-tiny text-right">Amount</th>
                    </tr>
                    <tr v-for="(deduction,idx) in voucherItems.dedcutions.filter(ded => !ded.isKra)" :key="`ded_${idx}`">
                        <td colspan="2" class="p-tiny">{{deduction.deductionName}}</td>
                        <td class="p-tiny">{{deduction.rate}}</td>
                        <td class="p-tiny">{{deduction.isKra ? `Yes` : `No`}}</td>
                        <td class="p-tiny">{{deduction.refNo || `-`}}</td>
                        <td class="p-tiny text-right">{{deduction.deductionAmount | numberFormat}}</td>
                    </tr>
                    <tr>
                        <td colspan="5" class="p-1"></td>
                        <th class="p-tiny text-right text-base">
                           Custom Total: {{customDeductions | numberFormat}}
                        </th>
                    </tr>
                    <tr>
                        <th colspan="6" class="p-tiny text-base">KRA Deductions</th>
                    </tr>
                    <tr v-for="(deduction,idx) in voucherItems.dedcutions.filter(ded => ded.isKra)" :key="`dedk_${idx}`">
                        <td colspan="2" class="p-tiny">{{deduction.deductionName}}</td>
                        <td class="p-tiny">{{deduction.rate}}</td>
                        <td class="p-tiny">{{deduction.isKra ? `Yes` : `No`}}</td>
                        <td class="p-tiny">{{deduction.refNo || `-`}}</td>
                        <td class="p-tiny text-right">{{deduction.deductionAmount | numberFormat}}</td>
                    </tr>
                    <tr class="border-b-2 border-gray-500">
                        <td colspan="5" class="p-1"></td>
                        <th class="p-tiny text-right text-base">
                            KRA Total: {{kraDeductions | numberFormat}}
                        </th>
                    </tr>
                    <tr>
                        <td colspan="5" class="p-1"></td>
                        <th class="p-tiny text-right text-base">
                            Total Deductions: {{(customDeductions + kraDeductions) | numberFormat}}
                        </th>
                    </tr>
                    <tr>
                        <td colspan="5" class="p-1"></td>
                        <th class="p-tiny text-right text-base">
                            Net Total: {{(total-(customDeductions + kraDeductions)) | numberFormat}}
                        </th>
                    </tr>
                </tbody>
            </table>  -->
        </div>
        <div class="my-2 p-2 bg-gray-300 w-full flex flex-wrap">
            <div class="flex-1">
                <h5 class="font-medium text-base">Date: 
                    {{ voucher.datePosted | dateFormat}}  </h5>
            </div> <div class="flex-1">
                <h5 class="font-medium text-base">Mode: 
                    {{ voucher.mode}}  </h5>
            </div><div class="flex-1">
                <h5 class="font-medium text-base">Amount: 
                    {{ voucher.paidAmount| numberFormat}}  </h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium text-base">Ref: 
                    {{ voucher.paymentRef }}
                </h5>
            </div>
            
        </div>
        <div class="md:w-1/2 w-full p-tiny">
             
                <h5 class="font-medium text-base">Desription: 
                {{ voucher.description }}</h5>
        </div> <div class="md:w-1/2 w-full p-tiny">
             
                <h5 class="font-medium text-base">Approval Memo: 
                {{ voucher.postMemo }}</h5>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button :class="cancel ? `text-base mr-6` : `text-sm mr-6`"
        class="btn-danger btn-sm rounded" 
            @click.prevent="$emit(`closeSlip`,false)">
                <i class="fa fa-times"></i> Close</button>
    <button :class="cancel ? `text-base mr-6` : `text-sm mr-6`"
        class="btn-primary btn-sm rounded" 
            @click.prevent="printPaymentSlip">
                <i class="fa fa-print"></i> Print</button>
    <!-- <button v-if="cancel" 
        class="btn-warning btn-sm text-base rounded" 
            @click.prevent="cancelVoucher">
                <i class="fa fa-ban"></i> Cancel Voucher</button> -->
  </template>
</tail-modal>
</template>